import { Box, Loader } from "@saviynt/design-system";
import { createRootRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { ShellLayout } from "../shell-components/ShellLayout";
import SSOCallbackPage from "../pages/SSOCallback/SSOCallbackPage";
import "../utils/devtools";

function RootComponent() {
  const [showRouterDevtools, setShowRouterDevtools] = useState(false);
  const { isAuthenticated, isAuthChecked } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleToggle = (event: CustomEvent) => {
      setShowRouterDevtools(event.detail);
    };
    window.addEventListener(
      "devtools-router-toggle",
      handleToggle as EventListener,
    );
    return () =>
      window.removeEventListener(
        "devtools-router-toggle",
        handleToggle as EventListener,
      );
  }, []);

  useEffect(() => {
    if (
      isAuthChecked &&
      !isAuthenticated &&
      window.location.pathname !== "/version"
    ) {
      navigate({ to: "/login" });
    }
  }, [isAuthenticated, isAuthChecked, navigate]);

  if (window.location.pathname === "/sso/callback") return <SSOCallbackPage />;
  if (window.location.pathname === "/version") return <Outlet />;

  if (!isAuthChecked) {
    return (
      <Box className="w-full h-screen flex justify-center items-center">
        <Loader kind="loop" format="main" size="medium" color="brand" />
      </Box>
    );
  }

  if (!isAuthenticated) return <Outlet />;

  return (
    <>
      <ShellLayout>
        <Outlet />
      </ShellLayout>
      {showRouterDevtools && <TanStackRouterDevtools />}
    </>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});
